import { CaptureUserAuthenticated } from './CaptureUserAuthenticated'
import { DialogTransitionProvider } from '@dtx-company/design-system/src/components/Dialog/DialogTransition/DialogTransitionProvider'
import { FC, ReactNode } from 'react'
import { FullPageErrorFallback } from '@dtx-company/inter-app/src/components/PageErrorFallback'
import { GooglePlaceAutocompleteGlobalStyles } from './GooglePlaceAutocompleteGlobalStyles'
import { LazyFeatureBundle, LazyMotion } from 'framer-motion'
import { ThemeProvider as LegacyThemeProvider } from 'styled-components'
import { LockedFeatureModalProvider } from '../../../shared/common/src/components/LockedFeatureModal/context/LockedFeatureModalProvider'
import { LoggerErrorBoundary } from '@dtx-company/logger'
import { ReduxProvider } from './ReduxProvider'
import { ThemeProvider } from '@dtx-company/design-system/src/components/ThemeProvider/ThemeProvider'
import legacyTheme from '@app/common/src/theme'

const loadFeatures: LazyFeatureBundle = () =>
  import('../../../utils/framer').then(res => res.default)

export const AppProviders: FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <LoggerErrorBoundary
      options={{ technicalArea: 'general' }}
      fallback={<FullPageErrorFallback />}
    >
      <ThemeProvider>
        <LegacyThemeProvider theme={legacyTheme}>
          <LazyMotion features={loadFeatures}>
            <DialogTransitionProvider>
              <ReduxProvider>
                <LockedFeatureModalProvider>
                  <CaptureUserAuthenticated />
                  {children}
                </LockedFeatureModalProvider>
              </ReduxProvider>
              <GooglePlaceAutocompleteGlobalStyles />
            </DialogTransitionProvider>
          </LazyMotion>
        </LegacyThemeProvider>
      </ThemeProvider>
    </LoggerErrorBoundary>
  )
}
